import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const NoShowText = styled.span<{ isNoShow: boolean }>`
  ${({ isNoShow, theme }) => css`
    ${theme.font.regular_12};
    color: ${isNoShow ? theme.color.error_01 : theme.color.gray_06};
  `}
`;
